import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ApiRequestService, ListViewComponent, TranslationPipe } from '@prekog/common-ui';
import { DiscountedProduct } from './discounted-product.model';
import { GetDiscountedProductsResponse } from './get-discounted-products.response';
import { UpdateDiscountedProductOrderRequest } from './update-discounted-products-order.request';

@Component({
    selector: 'app-orderdiscountedproducts',
    templateUrl: './order-discounted-products.component.html',
    styleUrls: ['./order-discounted-products.component.scss'],
    standalone: true,
    imports: [MatIconModule, FormsModule, RouterModule, DragDropModule, CommonModule, TranslationPipe, DragDropModule, ListViewComponent, ListViewComponent]
})
export class OrderdiscountedproductsComponent implements OnInit {
    discountedProducts?: DiscountedProduct[];
    filteredDiscountedProducts?: DiscountedProduct[];
    getDiscountedProductsURL = '/admin/getDiscountedProductsForOrdering';

    searchText = '';
    storeBaseUrl = '';
    updateDiscountedProductsOrderURL = '/admin/updateDiscountedProductsOrder';

    constructor(
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _apiRequestService: ApiRequestService
    ) {
        this.storeBaseUrl = _storeBaseUrl;
    }

    ngOnInit(): void {
        this.getDiscountedProducts();
    }

    getDiscountedProducts() {
        this._apiRequestService
            .sendRequest<{}, GetDiscountedProductsResponse>(this.storeBaseUrl, {}, true, this.getDiscountedProductsURL)
            .subscribe((response) => {
                this.discountedProducts = response.discountedProductList as DiscountedProduct[];
                this.filteredDiscountedProducts = this.discountedProducts;
            });
    }

    drop(event: CdkDragDrop<DiscountedProduct>): void {
        moveItemInArray(this.discountedProducts!, event.previousIndex, event.currentIndex);
    }

    updateDiscountedProductsOrder() {
        const updateDiscountedProductsOrderRequest: UpdateDiscountedProductOrderRequest = {
            discountedProductOrderList: this.discountedProducts!.map((discountedProduct, index) => ({
                productId: discountedProduct.productId,
                orderNumber: index
            }))
        };

        this._apiRequestService
            .sendRequest<
                {},
                GetDiscountedProductsResponse
            >(this.storeBaseUrl, updateDiscountedProductsOrderRequest, true, this.updateDiscountedProductsOrderURL, true)
            .subscribe();
    }
}
